import { render, staticRenderFns } from "./AlarmDetail.vue?vue&type=template&id=cf80f294"
import script from "./AlarmDetail.vue?vue&type=script&lang=js"
export * from "./AlarmDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports